var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    {
      class: {
        "pa-0 mx-0": !_vm.wrapper,
        "border border-grey-200 soli-round w-full h-auto flex flex-col py-1":
          _vm.wrapper,
      },
    },
    [_c("editor-content", { attrs: { editor: _vm.editor } })],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }